exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./example/containers/About.scss
 ** module id = 144
 ** module chunks = 0
 **/